module.exports = __webpack_public_path__ + "static/media/ios.254887c8.png";